import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class ExitOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
        this.createButton(this._target, this._onIconClicked.bind(this));
    }
    _onIconClicked() {
        this.openPopup(SkinKeyRegistry.EXIT_POPUP_SKIN, null, {
            needsOverlay: false,
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 150)
        });
    }
}